export default __webpack_public_path__ + "static/media/Boots of the Tireless Defender.9aed3309.jpg";